import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "noCommunication",
  "use": "noCommunication-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"noCommunication\"><title>noCommunication</title><path d=\"M10 5.61a1.87 1.87 0 0 0-.62 3.64v10.12a.625.625 0 1 0 1.25 0V9.25A1.88 1.88 0 0 0 10 5.61zm0 2.5a.62.62 0 1 1 .63-.63.63.63 0 0 1-.63.63zm-5.32 6.32a8.69 8.69 0 0 1-3.43-6.95A8.79 8.79 0 0 1 4 1.08a.62.62 0 0 0-.82-.91 10 10 0 0 0 .73 15.26.63.63 0 0 0 .88-.12.63.63 0 0 0-.12-.88zm0 0\" /><path d=\"M7 11.46a5 5 0 0 1 0-7.93.63.63 0 0 0-.76-1 6.33 6.33 0 0 0-1.83 2.15 6.26 6.26 0 0 0 0 5.62 6.29 6.29 0 0 0 1.79 2.15.628.628 0 1 0 .76-1zm9.25-3.98a6.18 6.18 0 0 0-.66-2.8 6.31 6.31 0 0 0-1.77-2.15.63.63 0 0 0-.76 1 5 5 0 0 1 0 7.93.628.628 0 1 0 .76 1 6.29 6.29 0 0 0 1.79-2.15 6.17 6.17 0 0 0 .67-2.81zm0 0\" /><path d=\"M19.14 3.43A10 10 0 0 0 16.82.17a.623.623 0 0 0-.85.91 8.79 8.79 0 0 1 2.79 6.4 8.7 8.7 0 0 1-3.43 6.95.63.63 0 0 0 .38 1.12.63.63 0 0 0 .38-.13A10.08 10.08 0 0 0 18.93 12a10 10 0 0 0 .21-8.55zm0 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/noCommunication.svg
// module id = 65dF
// module chunks = 6